export default "__VITE_ASSET__BClHS4M4__"